import React from "react";
import { Header } from "./components/header";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Home } from "./pages/home/home";
import { Manager } from "./pages/manager/manager";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { Client, Provider, cacheExchange, fetchExchange } from "urql";
import { CarPage } from "./pages/carPage/carPage";
import { Footer } from "./components/footer";
import { WhatIsRent } from "./pages/whatIsRent/whatIsRent";
import { ChiSiamo } from "./pages/chiSiamo/chiSiamo";
import { Furgoni } from "./pages/furgoni/furgoni";
import { Fisco } from "./pages/fisco/fisco";
import { Preventivo } from "./pages/preventivo/preventivo";
import { AllOffers } from "./pages/allOffers/allOffers";
import { Login } from "./pages/login/login";
import { Reviews } from "./pages/chiSiamo/reviews";
import { NoleggioUsato } from "./pages/noleggioUsato/noleggioUsato";

function PublicPage(props: { children: React.ReactNode }) {
  return (
    <>
      <Header />
      {props.children}
      <Reviews />
      <Footer />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PublicPage>
        <Home />
      </PublicPage>
    ),
  },
  {
    path: "/manager",
    element: (
      <>
        <Manager />
      </>
    ),
  },
  {
    path: "/carprice/:id",
    element: (
      <PublicPage>
        <CarPage />
      </PublicPage>
    ),
  },
  {
    path: "/noleggio/",
    element: (
      <PublicPage>
        <WhatIsRent />
      </PublicPage>
    ),
  },
  {
    path: "/noleggio-usato/",
    element: (
      <PublicPage>
        <NoleggioUsato />
      </PublicPage>
    ),
  },
  {
    path: "/chisiamo/",
    element: (
      <PublicPage>
        <ChiSiamo />
      </PublicPage>
    ),
  },
  {
    path: "/furgoni/",
    element: (
      <PublicPage>
        <Furgoni />
      </PublicPage>
    ),
  },
  {
    path: "/fisco/",
    element: (
      <PublicPage>
        <Fisco />
      </PublicPage>
    ),
  },
  {
    path: "/preventivo/",
    element: (
      <PublicPage>
        <Preventivo />
      </PublicPage>
    ),
  },
  {
    path: "/offerte/",
    element: (
      <PublicPage>
        <AllOffers />
      </PublicPage>
    ),
  },
  {
    path: "/login/",
    element: (
      <>
        <Login />
      </>
    ),
  },
]);

function App() {
  const password = localStorage.getItem("password");

  const headers =
    password ?
      {
        "x-hasura-admin-secret": password,
      }
    : [];
  const client = new Client({
    url:
      "https://gnehjbtszplnnrklqbwb.hasura.eu-central-1.nhost.run/v1/graphql" ||
      ("http://localhost:8080/v1/graphql" as string),
    exchanges: [cacheExchange, fetchExchange],
    fetchOptions: () => {
      return {
        headers,
      };
    },
  });

  return (
    <div className="App">
      <Provider value={client}>
        <FluentProvider theme={webLightTheme}>
          <RouterProvider router={router} />
        </FluentProvider>
      </Provider>
    </div>
  );
}

export default App;
